/* prettier-ignore */

const data = {
  common: {
    title: "Piggy Valut",
    description: "Piggy Valut Solution",
    buttons: {
      search: "Search",
      login: "Login",
      register: "Register",
      approve: "Approve",
      reject: "Reject",
      refresh: "Refresh",
      viewDetails: "View Details",
      back: "Back",
      cancel: "Cancel",
      confirm: "Confirm",
      save: "Save",
      saving: "Saving...",
      delete: "Delete",
      deleting: "Deleting...",
      hide: "Hide",
      show: "Show",
      close: "Close",
    },
    placeholders: {
      search: "Search...",
    },
    messages: {
      success: "Success",
      updateSuccess: "User information has been updated",
      loginSuccess: "Login successful",
      logoutSuccess: "Logout successful",
      registerSuccess: "Registration successful",
      criticalError: "Critical error occurred",
      forbidden: "Forbidden request",
      notAuthorized: "Not authorized",
      noData: "No data",
      tooManyRequests: "Please try again later. You are sending the same request too quickly.",
      blocked: "User is blocked",
      pending: "User is pending",
      ipBlocked: "IP is blocked",
      serverError: "Server error occurred",
      invalidInput: "Invalid input",
      invalidCredentials: "Username or password is incorrect",
      invalidReferrer: "Referrer does not exist",
      referrerRequired: "Referrer is required",
      ipBlockedFailed: "Failed to block IP",
      notAllowedPartner: "Not allowed partner",
      invalidPassword: "Failed to verify password",
      databaseError: "Database error occurred",
      usernameInUse: "Username is already in use",
      createUserError: "Failed to create user",
      failedFetch: "Failed to fetch data",
      failedFetchUser: "Failed to fetch user",
      failedFetchPendingUsers: "Failed to fetch pending users",
      failedFetchOnlineUsers: "Failed to fetch online users",
      failedFetchUserTree: "Failed to fetch user tree",
      failedFetchUsers: "Failed to fetch users",
      failedFetchUserUpline: "Failed to fetch user upline",
      failedFetchUserDownline: "Failed to fetch user downline",
      failedUpdate: "Failed to update data",
      failedUpdateUser: "Failed to update user",
      failedSave: "Failed to save data",
      vendorError: "Vendor error occurred",
      confirmDelete: "Are you sure you want to delete?",
      deleteSuccess: "User has been deleted",
      tokenRefreshed: "Token refreshed",
      tokenRefreshFailed: "Token refresh failed",
      invalidIpAddress: "Invalid IP address",
      invalidChipTransactionReason: "Invalid chip transaction reason",
      captchaExpired: "Captcha expired",
      captchaInvalid: "Captcha is invalid",
      insufficientChip: "Insufficient chip",
      insufficientPoint: "Insufficient point",
      failedCollectChips: "Failed to collect chips",
      failedGiveChips: "Failed to give chips",
      failedPointsToChips: "Failed to points to chips",
      notFoundHeadquarter: "Headquarter not found",
      notFoundUser: "User not found",
      failedFetchAdmin: "Failed to fetch admin",
      failedFetchHeadquarter: "Failed to fetch headquarter",
      adminNotAllowed: "Admin is not allowed",
      partnerNotAllowed: "Partner is not allowed",
      userNotAllowed: "User is not allowed",
      failedFetchTotalInquiries: "Failed to fetch total inquiries",
      failedFetchInquiries: "Failed to fetch inquiries",
      failedCreateInquiry: "Failed to create inquiry",
      failedUpdateInquiry: "Failed to update inquiry",
      failedFetchInquiry: "Failed to fetch inquiry",
      failedFetchTotalNotices: "Failed to fetch total notices",
      failedFetchNotices: "Failed to fetch notices",
      failedCreateNotice: "Failed to create notice",
      failedUpdateNotice: "Failed to update notice",
      failedIncrementNoticeViewCount: "Failed to increment notice view count",
      failedFetchNotice: "Failed to fetch notice",
      failedFetchBankingHistory: "Failed to fetch banking history",
      failedFetchTotalBankingHistory: "Failed to fetch total banking history",
      failedFetchDownlineBankingHistory: "Failed to fetch downline banking history",
      failedFetchDownlineTotalBankingHistory: "Failed to fetch downline total banking history",
      failedAddBankingHistory: "Failed to add banking history",
      failedUpdateBankingHistoryStatus: "Failed to update banking history status",
      failedFetchChipTransactionHistory: "Failed to fetch chip transaction history",
      failedFetchTotalChipTransactionHistory: "Failed to fetch total chip transaction history",
      failedFetchDownlineChipTransactionHistory: "Failed to fetch downline chip transaction history",
      failedFetchDownlineTotalChipTransactionHistory: "Failed to fetch downline total chip transaction history",
      failedAddChipTransactionHistory: "Failed to add chip transaction history",
      failedFetchGameBetHistoryByCallbackId: "Failed to fetch game bet history by callback ID",
      failedFetchGameBetHistory: "Failed to fetch game bet history",
      failedFetchTotalGameBetHistory: "Failed to fetch total game bet history",
      failedFetchDownlineGameBetHistory: "Failed to fetch downline game bet history",
      failedFetchDownlineTotalGameBetHistory: "Failed to fetch downline total game bet history",
      failedAddGameBetHistory: "Failed to add game bet history",
      failedFetchChipChangeHistory: "Failed to fetch chip change history",
      failedFetchTotalChipChangeHistory: "Failed to fetch total chip change history",
      failedAddChipChangeHistory: "Failed to add chip change history",
      failedFetchGameCallbackHistory: "Failed to fetch game callback history",
      failedFetchTotalGameCallbackHistory: "Failed to fetch total game callback history",
      failedAddGameCallbackHistory: "Failed to add game callback history",
      failedUpdateGameCallbackHistory: "Failed to update game callback history",
      failedDeleteGameCallbackHistory: "Failed to delete game callback history",
      failedFetchGamePlayHistory: "Failed to fetch game play history",
      failedFetchTotalGamePlayHistory: "Failed to fetch total game play history",
      failedAddGamePlayHistory: "Failed to add game play history",
      failedFetchLoginHistory: "Failed to fetch login history",
      failedFetchTotalLoginHistory: "Failed to fetch total login history",
      failedAddLoginHistory: "Failed to add login history",
      failedFetchPointChangeHistory: "Failed to fetch point change history",
      failedFetchTotalPointChangeHistory: "Failed to fetch total point change history",
      failedAddPointChangeHistory: "Failed to add point change history",
      failedFetchSettings: "Failed to fetch settings",
      failedFetchSettingByKey: "Failed to fetch setting by key",
      failedCreateSetting: "Failed to create setting",
      noFieldsToUpdateSetting: "No fields to update",
      settingNotFound: "Setting not found",
      failedUpdateSetting: "Failed to update setting",
      failedDeleteSetting: "Failed to delete setting",
      failedUpdateMultipleSettings: "Failed to update multiple settings",
      failedFetchUserDownlineTotalFinance: "Failed to fetch user downline total finance",
      failedFetchUserDownlineSettlement: "Failed to fetch user downline settlement",
      failedFetchMyTotalAddedChips: "Failed to fetch my total added chips",
      failedFetchMyTotalSubtractedChips: "Failed to fetch my total subtracted chips",
      failedFetchMyMoneyChanges: "Failed to fetch my money changes",
      failedFetchTodaysNewUsers: "Failed to fetch today's new users count",
      failedFetchTodayStats: "Failed to fetch today's stats",
      failedFetchTotalPendingUsers: "Failed to fetch total pending users count",
      failedFetchTotalOnlineUsers: "Failed to fetch total online users count",
      failedFetchTotalPendingInquiries: "Failed to fetch total pending inquiries count",
      failedFetchTotalDepositAndWithdraw: "Failed to fetch total deposit and withdraw info",
      failedFetchMonitoringStats: "Failed to fetch monitoring stats",
      failedUpdateUserFinance: "Failed to update user finance",
      failedAddUserChip: "Failed to add user chip",
      failedAddUserPoint: "Failed to add user point",
      failedSubtractUserChip: "Failed to subtract user chip",
      failedCollectSubUserChips: "Failed to collect sub-user chips",
      failedGiveChipsToSubUser: "Failed to give chips to sub-user",
      failedUpdateUserStatus: "Failed to update user status",
      failedUpdateUserRole: "Failed to update user role",
      failedUpdateUserOnlineStatus: "Failed to update user online status",
      failedUpdateGameVendorForDownline: "Failed to update game vendor for downline",
      failedCreateUsers: "Failed to create multiple users",
      failedFetchUserById: "Failed to fetch user by ID",
      failedFetchUserByVendorId: "Failed to fetch user by vendor ID",
      failedFetchUserFinance: "Failed to fetch user finance",
      failedFetchUserRowsByRole: "Failed to fetch user rows by role",
      failedFetchAdminId: "Failed to fetch admin ID",
      failedFetchHeadquarterId: "Failed to fetch headquarter ID",
      failedFetchUsersByReferrer: "Failed to fetch users by referrer",
      failedFetchUsersWithoutReferrer: "Failed to fetch users without referrer",
      failedFetchPendingUsersTotal: "Failed to fetch total pending users",
      failedFetchOnlineUsersTotal: "Failed to fetch total online users",
      failedFetchUserDetail: "Failed to fetch user detail.",
      userNotFound: "User not found.",
      failedFetchVendorHistory: "Failed to fetch vendor history.",
      failedAddVendorHistory: "Failed to add vendor history.",
      failedUpdateVendorHistory: "Failed to update vendor history.",
      referrerNotFound: "Referrer not found",
      failedToGetAdminId: "Failed to get admin ID",
      failedToGetHeadquarterId: "Failed to get headquarter ID",
      failedToGetUserDetail: "Failed to get user detail",
      failedToGetUserFinance: "Failed to get user finance",
      failedFetchUserByRole: "Failed to fetch user by role",
      failedAddBetAmount: "Failed to add bet amount",
      invalidReason: "Invalid reason",
      refreshTokenRequired: "Refresh token is required",
    },
    pagination: {
      previous: "Previous",
      next: "Next",
      page: "Page",
    },
    roles: {
      admin: "Admin",
      headquarter: "Headquarters",
      headquarter_branch: "Headquarters Branch",
      branch: "Branch",
      distributor: "Distributor",
      store: "Store",
      user: "User",
    },
    appBar: {
      search: {
        placeholder: "Search...",
      },
      userProfile: "Profile",
      userSettings: "Settings",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
      logout: "Logout",
    },
    loading: {
      loading: "Loading...",
      error: "Error occurred: ",
    },
    search: {
      placeholder: "Enter search keyword",
      button: "Search",
      datePlaceholder: "Select date",
    },
    userTree: {
      title: "Organization Chart",
    },
    status: {
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      canceled: "Canceled",
    },
    gameVendorSelect: {
      officialLabel: "Official Game Vendor",
      unofficialLabel: "Unofficial Game Vendor",
      officialPlaceholder: "Select Official Game Vendor",
      unofficialPlaceholder: "Select Unofficial Game Vendor",
      save: "Save",
      none: "None",
    },
    dateRangeSelector: {
      startDatePlaceholder: "Start Date",
      endDatePlaceholder: "End Date",
      selectPlaceholder: "Select Period",
      periods: {
        day: "Today",
        week: "1 Week",
        twoWeeks: "2 Weeks",
        month: "1 Month",
        threeMonths: "3 Months",
        sixMonths: "6 Months",
        year: "1 Year",
        custom: "Custom",
      },
    },
  },
  auth: {
    login: "Login",
    register: "Register",
    loginDescription: "Enter username and password to login",
    registerDescription: "Create new account",
    email: "Email",
    password: "Password",
    username: "Username",
    referrer: "Referrer",
    referrerPlaceholder: "Enter referrer's username",
    confirmPassword: "Confirm Password",
    loginButton: "Login",
    registerButton: "Register",
    captcha: "Security Question",
    captchaPlaceholder: "Enter answer",
    loginProcessing: "Logging in...",
    registerProcessing: "Processing...",
    hasAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    goToLogin: "Go to Login",
    goToRegister: "Go to Register",
    minLengthUsername: "Username must be at least 3 characters",
    minLengthPassword: "Password must be at least 8 characters",
    invalidCaptcha: "Security question answer is incorrect",
    passwordMismatch: "Passwords do not match",
    loginSuccess: "Login successful",
    registerSuccess: "Registration successful",
    refresh: "Refresh",
  },
  sidebar: {
    systemManagement: "System/Notice",
    partnerManagement: "Partner Management",
    userManagement: "User Management",
    bankingManagement: "Banking Management",
    bettingStatus: "Betting Status & Settlement",
    apiDocs: "API Docs",
    settings: "Settings",
  },
  statsOverview: {
    balance: "Balance",
    pendingApproval: "Pending Approval",
    depositRequest: "Deposit Request",
    withdrawRequest: "Withdraw Request",
    inquiry: "1:1 Inquiry",
    currentUsers: "Current Users",
    cases: "Cases",
    users: "Users",
    userBalance: "User Chip Balance",
    userPoint: "User Point Balance",
    partnerBalance: "Partner Chip Balance",
    partnerPoint: "Partner Point Balance",
  },
  dashboard: {
    title: "Dashboard",
    desc: "Admin Dashboard",
    registeredUsers: "Registered Users",
    activeUsers: "Active Users",
    systemStatus: "System Status",
    systemNormal: "Normal",
    allSystemsOperational: "All Systems Operational",
    topStats: {
      chip: {
        title: "Chip Balance",
        vendorBalance: "Vendor Chip Balance",
      },
      point: {
        title: "Point Balance",
        convertButton: "Convert to Chip",
      },
      user: {
        title: "User",
        listButton: "Affiliated Users List",
      },
    },
    moneyStatus: {
      userBalance: "User Chip Balance",
      userPoint: "User Point Balance",
      partnerBalance: "Partner Chip Balance",
      partnerPoint: "Partner Point Balance",
    },
    transactionSummary: {
      deposit: "Deposit",
      withdraw: "Withdraw",
      chipGive: "Chip Given",
      chipCollect: "Chip Collected",
      newUsers: "Today's New Users",
      profit: "Today's Betting Profit",
      profitDesc: "(Bet - Win - Rolling)",
    },
    transactionDetails: {
      title: "Balance = Chip + Rolling, Deposit/Withdraw is the sum of deposits/withdrawals to affiliated members",
      search: "Search",
      prevBalance: "Previous Balance",
      deposit: "Deposit",
      withdraw: "Withdraw",
      currentBalance: "Current Balance",
      bettingWinning: "Bet / Win",
      rolling: "Rolling",
      userBalanceLabel: "User Balance",
      partnerBalanceLabel: "Partner Balance",
      depositLabel: "Deposit",
      chipGiveLabel: "Chip Given",
      totalLabel: "Total",
      withdrawLabel: "Withdraw",
      chipCollectLabel: "Chip Collected",
      bettingLabel: "Betting Amount",
      winningLabel: "Winning Amount",
      bettingResultLabel: "Bet - Win",
      totalRollingLabel: "Total Rolling",
      actualRollingLabel: "Actual Rolling",
    },
    transactionHistory: {
      title: "Transaction History",
      search: "Search",
      increase: {
        title: "Balance Increase",
        headDeposit: "Company Deposit",
        upperChipGive: "Upper Chip Give",
        lowerChipCollect: "Lower Chip Collect",
        rollingConvert: "Rolling Convert",
        total: "Increase Total",
      },
      decrease: {
        title: "Balance Decrease",
        headWithdraw: "Company Withdraw",
        upperChipCollect: "Upper Chip Collect",
        lowerChipGive: "Lower Chip Give",
        total: "Decrease Total",
      },
    },
    notice: {
      title: "Notice",
      columns: {
        id: "#",
        title: "Title",
        createdAt: "Created At",
      },
    },
  },
  users: {
    list: {
      title: "User List",
      desc: "Manage registered users",
      columns: {
        username: "User ID",
        details: "Details",
        banking: "Recharge/Exchange",
        chip: "Chip Balance",
        point: "Point Balance",
        affiliation: "Affiliation",
        depositWithdraw: "Deposit/Withdraw",
        slotStats: "(Slot)/Bet/Win/Rolling",
        casinoStats: "(Casino)/Bet/Win/Rolling",
        sportsStats: "(Sports)/Bet/Win/Rolling",
      },
      filters: {
        byUsername: "By User ID",
        byChip: "By Chip Balance",
        byLatest: "By Latest",
        byOldest: "By Oldest",
      },
    },
    pending: {
      title: "Pending Users",
      desc: "Manage pending users",
      columns: {
        username: "User ID",
        details: "Details",
        status: "Status",
        headquarter: "Headquarters",
        branch: "Branch",
        distributor: "Distributor",
        store: "Store",
        createdAt: "Created At",
        contact: "Contact",
        actions: "Actions",
      },
      approve: "Approve",
      reject: "Reject",
      pendingStatus: "Pending",
      viewDetails: "View Details",
    },
    online: {
      title: "Online Users",
      desc: "Manage online users",
      columns: {
        username: "User ID",
        details: "Details",
        accountHolder: "Account Holder",
        affiliation: "Affiliation",
        banking: "Recharge/Exchange",
        chip: "Chip Balance",
        depositWithdraw: "Total Deposit/Withdraw",
        slotStats: "(Slot)/Bet/Win/Rolling",
        casinoStats: "(Casino)/Bet/Win/Rolling",
        sportsStats: "(Sports)/Bet/Win/Rolling",
        lastPlayedGame: "Last Game",
      },
      noLastGame: "No Record",
    },
    chip: {
      giveTitle: "Chip Give",
      collectTitle: "Chip Collect",
      giftTitle: "Chip Gift",
      giveChip: "Give Chip",
      collectChip: "Collect Chip",
      giftChip: "Gift Chip",
      description: "Enter the amount and reason, then click the confirm button.",
      amount: "Amount",
      memo: "Memo",
      memoPlaceholder: "Enter the memo",
      errors: {
        invalidAmount: "Enter a valid amount",
        actionFailed: "Action failed",
      },
    },
    status: {
      active: "Active",
      pending: "Pending",
      rejected: "Rejected",
      block: "Blocked",
      online: "Online",
      offline: "Offline",
    },
    detail: {
      title: "User Details",
      desc: "Manage user details",
      tabs: {
        userInfo: "User Information",
        loginHistory: "Login History",
        messages: "Messages",
        chipChangeHistory: "Chip change History",
        rechargeHistory: "Recharge History",
        exchangeHistory: "Exchange History",
        chipReceivedHistory: "Chip Received History",
        chipSentHistory: "Chip Sent History",
        gamePlayHistory: "Game Play History",
        gameBetHistory: "Game Betting History",
        restrictedGameBetting: "Restricted Game Betting",
        pragmatic: "Pragmatic",
        userLogs: "User Logs",
      },
      userSummary: {
        role: "Role",
        username: "Username",
        chip: "Chip",
        point: "Point",
      },
      userInfo: {
        title: "User Details",
        basicInfo: "Basic Information",
        moneyInfo: "Financial Information",
        gameInfo: "Game Information",
        bankInfo: "Bank Information",
        number: "Number",
        password: "Password",
        username: "Username",
        contact: "Contact",
        status: "Status",
        gameVendor: "Game Vendor",
        gameVendorPlaceholder: "Select Game Vendor",
        chip: "Chip",
        point: "Point",
        totalDeposit: "Total Deposit",
        totalWithdraw: "Total Withdraw",
        slotBet: "Slot Betting",
        slotWin: "Slot Winning",
        casinoBet: "Casino Betting",
        casinoWin: "Casino Winning",
        sportsBet: "Sports Betting",
        sportsWin: "Sports Winning",
        casinoBetLimit: "Live Casino Betting Limit",
        casinoWinLimit: "Live Casino Winning Limit",
        bankName: "Bank Name",
        bankAccount: "Account Number",
        bankAccountHolder: "Account Holder",
        memo: "Memo",
        memoPlaceholder: "Enter memo",
        createdAt: "Registration Date",
        lastLogin: "Last Login",
        blockRejectReason: "Block/Reject Reason",
        blockRejectReasonPlaceholder: "Enter block or reject reason",
      },
      loginHistory: {
        title: "Login History",
        columns: {
          ipAddr: "IP Address",
          isSuccess: "Success",
          createdAt: "Access Time",
          actions: "Actions",
          blockIP: "Block IP",
        },
      },
      chipChangeHistory: {
        title: "Chip Change History",
        columns: {
          amountBefore: "Before",
          amountAfter: "After",
          amountDiff: "Change",
          sender: "Sender",
          receiver: "Receiver",
          reason: "Reason",
          referenceValue: "Reference Value",
          rollingBefore: "Rolling (Before)",
          rollingAfter: "Rolling (After)",
          createdAt: "Change Time",
        },
      },
      rechargeHistory: {
        title: "Recharge History",
        columns: {
          amountBefore: "Before",
          amountAfter: "After",
          requestAmount: "Request Amount",
          bankInfo: "Bank Info",
          status: "Status",
          requestedAt: "Requested At",
          processedAt: "Processed At",
          memo: "Memo",
        },
      },
      exchangeHistory: {
        title: "Exchange History",
        columns: {
          amountBefore: "Before",
          amountAfter: "After",
          requestAmount: "Request Amount",
          bankInfo: "Bank Info",
          status: "Status",
          requestedAt: "Requested At",
          processedAt: "Processed At",
          memo: "Memo",
        },
      },
      chipReceiveHistory: {
        title: "Chip Received History",
        columns: {
          receiverId: "Receiver ID",
          receiverUsername: "Receiver Username",
          receiverRole: "Receiver Role",
          amount: "Chip Amount",
          reason: "Reason",
          memo: "Memo",
          createdAt: "Created At",
        },
      },
      chipSendHistory: {
        title: "Chip Sent History",
        columns: {
          senderId: "Sender ID",
          senderUsername: "Sender Username",
          senderRole: "Sender Role",
          amount: "Chip Amount",
          reason: "Reason",
          memo: "Memo",
          createdAt: "Created At",
        },
      },
      gamePlayHistory: {
        title: "Game Play History",
        columns: {
          supplier: "Supplier",
          gameName: "Game Name",
          executionTime: "Execution Time",
        },
      },
      gameBetHistory: {
        title: "Game Bet History",
        columns: {
          supplier: "Supplier",
          gameName: "Game Name",
          roundId: "Round ID",
          type: "Type",
          betAmount: "Bet Amount",
          winAmount: "Win Amount",
          balance: "Balance",
          betTime: "Bet Time",
          details: "Details",
        },
      },
    },
    creation: {
      title: "User Creation",
      desc: "Create new {0}",
      username: "Username",
      usernamePlaceholder: "Enter username",
      password: "Password",
      passwordPlaceholder: "Enter password",
      count: "Count",
      countPlaceholder: "Enter count",
      contact: "Contact",
      contactPlaceholder: "Enter contact",
      bank: "Bank",
      bankSelect: "=== Select ===",
      bankKookmin: "Kookmin",
      bankShinhan: "Shinhan",
      bankWoori: "Woori",
      bankNonghyup: "Nonghyup",
      bankHana: "Hana",
      accountNumber: "Account Number",
      accountNumberPlaceholder: "Enter account number",
      accountHolder: "Account Holder",
      accountHolderPlaceholder: "Enter account holder",
      errors: {
        requiredFields: "Enter username and password",
        invalidCount: "Count must be greater than 0",
      },
      rollingRateSlot: "Rolling Rate (Slot)",
      losingRateSlot: "Losing Rate (Slot)",
      rollingRateCasino: "Rolling Rate (Casino)",
      losingRateCasino: "Losing Rate (Casino)",
      rollingRateSports: "Rolling Rate (Sports)",
      losingRateSports: "Losing Rate (Sports)",
    },
  },
  partners: {
    common: {
      add: "Add Partner",
    },
    list: {
      all: {
        title: "Partner List",
        desc: "Manage registered partners",
      },
      head: {
        title: "Headquarter List",
        desc: "Manage registered headquarter",
      },
      headBranch: {
        title: "Headquarter Branch List",
        desc: "Manage registered headquarter branch",
      },
      branch: {
        title: "Branch List",
        desc: "Manage registered branch",
      },
      distributor: {
        title: "Distributor List",
        desc: "Manage registered distributor",
      },
      store: {
        title: "Store List",
        desc: "Manage registered store",
      },
      search: {
        placeholder: "Enter Partner Username",
      },
      columns: {
        username: "User ID",
        details: "Details",
        role: "Role",
        banking: "Recharge/Exchange",
        chip: "Chip Balance",
        point: "Point Balance",
        depositWithdraw: "Deposit/Withdraw",
        rollingPercentage: {
          slot: "Rolling % (Slot)",
          casino: "Rolling % (Casino)",
          sports: "Rolling % (Sports)",
        },
        losingPercentage: {
          slot: "Losing % (Slot)",
          casino: "Losing % (Casino)",
          sports: "Losing % (Sports)",
        },
        createdAt: "Created At",
        hqTransactions: "HQ Deposit/Withdraw",
        chipTransactions: "Chip Given/Collected",
        betting: {
          casino: "Bet(Casino)",
          slot: "Bet(Slot)",
          sports: "Bet(Sports)",
        },
        downlineManagement: "Downline Management",
        createDownline: "Create Downline",
      },
      statsCard: {
        basicInfo: {
          title: "Basic Info",
          type: "Type",
          username: "Username",
          chipAndPointBalance: "Chip / Point Balance",
          contact: "Contact",
          bankName: "Bank Name",
          bankAccount: "Account Number",
          accountHolder: "Account Holder",
        },
        rollingAndLosing: {
          title: "Rolling & Losing",
          convertButton: "Convert to Balance",
          rollingPercentage: {
            slot: "Rolling % (Slot)",
            casino: "Rolling % (Casino)",
            sports: "Rolling % (Sports)",
          },
          losingPercentage: {
            slot: "Losing % (Slot)",
            casino: "Losing % (Casino)",
            sports: "Losing % (Sports)",
          },
        },
        bettingAndRolling: {
          title: "Betting & Rolling",
          bettingWinning: {
            title: "Bet / Win",
            slot: "Bet / Win (Slot)",
            casino: "Bet / Win (Casino)",
            sports: "Bet / Win (Sports)",
          },
          rolling: {
            slot: "Rolling (Slot)",
            casino: "Rolling (Casino)",
            sports: "Rolling (Sports)",
          },
        },
        moneyMovement: {
          title: "Money Movement",
          totalDeposit: "Total Deposit",
          totalWithdraw: "Total Withdraw",
          totalChipGive: "Total Chip Given",
          totalChipCollect: "Total Chip Collected",
        },
      },
    },
    chipTransfer: {
      title: "Partner Chip Transfer",
      desc: "Manage partner chip transfers",
      columns: {
        fromUser: "Sender",
        fromRole: "Sender Role",
        toUser: "Receiver",
        toRole: "Receiver Role",
        amount: "Amount",
        memo: "Memo",
        createdAt: "Transfer Time",
      },
    },
    partnerUserChipTransfer: {
      title: "Partner ↔ User Chip Transfer",
      desc: "Manage Chip transfers between partners and users",
      search: {
        placeholder: "Enter partner or username",
      },
      columns: {
        partnerUsername: "Partner Name",
        partnerRole: "Partner Role",
        username: "Username",
        giveAmount: "Given Amount",
        collectAmount: "Collected Amount",
        createdAt: "Time",
      },
    },
  },
  banking: {
    rechargeHistory: {
      title: "Recharge History",
      desc: "Recharge history page",
      columns: {
        id: "#",
        type: "Type",
        amount: "Recharge Amount",
        countAndTotal: "Recharge Count / Total",
        balanceChange: "Before / After Recharge",
        username: "Username",
        affiliation: "Affiliation",
        bankName: "Bank Name",
        accountHolder: "Account Holder",
        dates: "Request Time / Process Time",
        status: "Status",
        details: "Details",
        memo: "Memo",
        deposit: "Deposit",
        withdraw: "Withdraw",
      },
    },
    exchangeHistory: {
      title: "Exchange History",
      desc: "Exchange history page",
      columns: {
        id: "#",
        type: "Type",
        amount: "Exchange Amount",
        countAndTotal: "Exchange Count / Total",
        balanceChange: "Before / After Exchange",
        username: "Username",
        affiliation: "Affiliation",
        bankName: "Bank Name",
        accountHolder: "Account Holder",
        dates: "Request Time / Process Time",
        status: "Status",
        details: "Details",
        memo: "Memo",
        deposit: "Deposit",
        withdraw: "Withdraw",
      },
    },
  },
  notices: {
    list: {
      title: "Notice Management",
      desc: "Notice management page",
      createButton: "Create Notice",
      columns: {
        title: "Title",
        status: "Status",
        viewCount: "Views",
        createdAt: "Created At",
        updatedAt: "Updated At",
        actions: "Actions",
        pinButton: "Pin",
        unpinButton: "Unpin",
        viewButton: "View",
        editButton: "Edit",
        deleteButton: "Delete",
      },
    },
    detail: {
      title: "Notice Details",
      desc: "Notice details page",
      notFound: "Notice not found",
    },
    edit: {
      title: "Edit Notice",
      desc: "Edit notice page",
      titleLabel: "Title",
      contentLabel: "Content",
      statusLabel: "Status",
      pinnedLabel: "Pin to Top",
    },
    delete: {
      title: "Delete Notice",
      desc: "Are you sure you want to delete this notice?",
    },
    status: {
      all: "All",
      draft: "Draft",
      published: "Published",
      deleted: "Deleted",
    },
  },
  inquiry: {
    types: {
      deposit: "Recharge Inquiry",
      withdrawal: "Exchange Inquiry",
      account: "Account Inquiry",
      other: "Other Inquiry",
    },
  },
  inquiries: {
    list: {
      title: "1:1 Inquiry",
      desc: "Inquiry list page",
      columns: {
        title: "Title",
        status: "Status",
        creator: "Creator",
        createdAt: "Created At",
        answerer: "Answerer",
        answeredAt: "Answered At",
      },
      search: {
        placeholder: "Search by title or content",
      },
      noData: "No inquiry history",
    },
    detail: {
      title: "Inquiry Details",
      desc: "Inquiry details page",
      notFound: "Inquiry not found",
    },
    status: {
      all: "All",
      pending: "Pending",
      inProgress: "In Progress",
      completed: "Completed",
      deleted: "Deleted",
    },
    answer: {
      title: "Answer",
      status: "Status",
      content: "Content",
      placeholder: "Enter your answer",
      submit: "Submit Answer",
      success: "Answer submitted successfully",
      error: "Failed to submit answer",
      required: "Please enter an answer",
    },
  },
  bettingStatus: {
    common: {
      rollingDesc: "※ Rolling = Betting x Rolling%, ※ Actual = Rolling - Downline Rolling",
      losingDesc: "※ Losing = (Betting - Winning - Total Rolling) x Rolling%, ※ Actual = Losing - Downline Losing",
      selectedPartner: "Selected Partner Betting & Rolling Data",
      downlinePartners: "Downline Partners Betting & Rolling Data",
    },
    slot: {
      title: "Betting Status(Slot)",
      desc: "Slot betting status page",
    },
    casino: {
      title: "Betting Status(Casino)",
      desc: "Casino betting status page",
    },
    sports: {
      title: "Betting Status(Sports)",
      desc: "Sports betting status page",
    },
    slotHistory: {
      title: "Betting History(Slot)",
      desc: "Slot betting history page",
    },
    casinoHistory: {
      title: "Betting History(Casino)",
      desc: "Casino betting history page",
    },
    sportsHistory: {
      title: "Betting History(Sports)",
      desc: "Sports betting history page",
    },
    losingSettlement: {
      slot: {
        title: "Losing Settlement(Slot)",
        desc: "Losing settlement page for Slot",
      },
      casino: {
        title: "Losing Settlement(Casino)",
        desc: "Losing settlement page for Casino",
      },
      sports: {
        title: "Losing Settlement(Sports)",
        desc: "Losing settlement page for Sports",
      },
      columns: {
        role: "Role",
        partnerName: "Partner Name",
        totalPartnerDeposit: "Partner Total Deposit",
        totalPartnerWithdraw: "Partner Total Withdraw",
        totalBetting: "Total Betting",
        totalWinning: "Total Winning",
        bettingResult: "Total Betting - Total Winning",
        rollingPercentage: "Rolling %",
        totalRolling: "Total Rolling",
        actualRolling: "Actual Rolling",
        losingPercentage: "Losing %",
        losingAmount: "Losing Amount",
        settlementAmount: "Settlement Amount",
        downlineSettlementAmount: "Downline Settlement Amount",
        actualPaymentAmount: "Actual Payment Amount",
      },
    },
    lossAdjustment: {
      title: "Loss Adjustment",
      desc: "Loss adjustment page",
      columns: {
        headquarter: "Headquarter",
        branch: "Branch",
        storeUsername: "Store Username",
        yesterdayBetting: "Yesterday Betting",
        yesterdayWin: "Yesterday Win",
        yesterdayRolling: "Yesterday Rolling",
        subtract: "Subtract",
        loss: "LOSS",
        add: "Add",
      },
      buttons: {
        setAll0: "Set All to 0",
        setAll5: "Set All to 5",
        setAll10: "Set All to 10",
        setAll15: "Set All to 15",
        setAll20: "Set All to 20",
      },
    },
    lossRecovery: {
      title: "Loss Recovery",
      desc: "Loss recovery page",
      columns: {
        storeName: "Store Name",
        username: "Username",
        gameName: "Game Name",
        date: "Date",
        bettingAmount: "Betting Amount",
        winningAmount: "Winning Amount",
        rollingAmount: "Rolling Amount",
        storeRecoveryStatus: "Store Recovery Status",
        userRecoveryStatus: "User Recovery Status",
        status: "Status",
      },
    },
    bettingStatusColumns: {
      role: "Role",
      partnerName: "Partner Name",
      totalPartnerDeposit: "Partner Total Deposit",
      totalPartnerWithdraw: "Partner Total Withdraw",
      totalBetting: "Total Betting",
      totalWinning: "Total Winning",
      bettingResult: "Betting - Winning",
      rollingPercentage: "Rolling %",
      totalRolling: "Total Rolling",
      actualRolling: "Actual Rolling",
      bettingProfit: "Betting Profit",
      currentChip: "Current Chip",
      currentRolling: "Current Rolling",
    },
  },
  swagger: {
    title: "API Documentation",
    description: "Piggy Vault Admin API Documentation.",
  },
  settings: {
    title: "Settings",
    description: "Manage system settings",
    tabs: {
      general: "General",
      currency: "Currency",
      exchange: "Exchange Rate",
      game: "Game",
      etc: "Etc",
    },
    groups: {
      general: {
        title: "General Settings",
        description: "Configure general system settings.",
      },
      currency: {
        title: "Currency Settings",
        description: "Manage currency display and standard settings.",
      },
      exchange: {
        title: "Exchange Rate Settings",
        description: "Manage USDT exchange rate related settings.",
      },
      game: {
        title: "Game Settings",
        description: "Configure game related settings, including vendors.",
      },
      etc: {
        title: "Other Settings",
        description: "Manage other miscellaneous settings.",
      },
    },
    fields: {
      site_name: {
        label: "Site Name",
        description: "The name of the website.",
      },
      maintenance: {
        label: "Maintenance Mode",
        description: "Enable or disable site maintenance mode. (on/off)",
      },
      std_currency: {
        label: "Standard Currency",
        description: "The standard currency for calculations.",
      },
      dsp_currency: {
        label: "Display Currency",
        description: "The currency displayed to users.",
      },
      usdt_exchange_rate: {
        label: "USDT Exchange Rate Settings",
        description: "Editor for USDT exchange rate JSON data.",
      },
      std_game_vendor_id: {
        label: "Standard Game Vendor",
        description: "Default game vendor ID.",
      },
      // 다른 필드들에 대한 번역도 여기에 추가할 수 있습니다.
    },
    messages: {
      settingKeyNotFound: "Index for setting key '$key' could not be found",
      loadingSettings: "Loading settings...",
      errorLoadingSettings: "Error loading settings",
    },
    save_success: "Settings saved successfully!",
  },
  usdtExchangeRateEditor: {
    rawJsonEditorTitle: "Raw JSON Editor",
    exchangeRateAndWalletSettingsTitle: "Exchange Rate and Wallet Settings",
    usdtExchangeRateLabel: "USDT Exchange Rate (ex_rate)",
    myWalletUrlLabel: "My Wallet URL (my_wallet)",
    quickAmountsSettingsTitle: "Quick Amount Settings:",
    quickAmounts: {
      hide: "(Hide)",
      show: "(Show)",
      amountPlaceholder: "Amount",
      labelPlaceholder: "Label (e.g. $10)",
      addAmountButton: "Add Quick Amount",
    },
    addLanguagePrompt: "Enter language code to add (e.g. th):",
    languageExistsError: "Language settings already exist.",
    addNewLanguageQuickAmountButton: "Add New Language Quick Amount",
    wallets: {
      title: "Withdrawal Wallet List (wallets)",
      walletNumberLabel: "Wallet",
      namePlaceholder: "Wallet Name (e.g. Polygon Tether)",
      addressPlaceholder: "Wallet Address",
      qrPlaceholder: "QR Code Image Path (e.g. /uploads/polygon-img.jpeg)",
      deleteWalletButton: "Delete This Wallet",
      addWalletButton: "Add Withdrawal Wallet",
    },
    errors: {
      invalidJsonParse: "Invalid JSON format",
      failedStringifyJson: "Failed to convert JSON string (onChange)",
      invalidJsonFormatOrUseUI:
        "Invalid JSON format. Please edit directly or use the UI below.",
    },
    rawJsonEditor: {
      editJsonDirectlyLabel: "Edit JSON Directly",
      warningMessage:
        "Warning: Settings may not be saved correctly if JSON format is incorrect.",
    },
    loadingEditor: "Loading editor...",
  },
};

export default data;
